import React, { useEffect, useState } from "react";
import TableContainer from "../TableContainer";
import { HStack, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import NoOflinesText from "../NoOflinesText";
import formatDuration from "../../lib/formatDuration";
import formatDate from "../../lib/formatDate";
import UpdateSilabusModal from "./UpdateSilabusModal";
import OrderSilabus from "./OrderSilabus";
import DeleteSilabusModal from "./DeleteSilabusModal";
import { Silabus } from "../../const/types";
import NoData from "../NoData";
import ComponentSpinner from "../ComponentSpinner";
import { useParams } from "react-router-dom";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";
import VideoPreviewOnTable from "./VideoPreviewOnTable";
import useDataChanges from "../../globalState/useDataChanges";

type Props = {
  search: string;
  orderLoading: boolean;
  setOrderLoading: (newState: boolean) => void;
};

export default function SilabusTable({
  search,
  orderLoading,
  setOrderLoading,
}: Props) {
  const [data, setData] = useState<Silabus[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams();
  const { trigger } = useTrigger();
  const { dataChanges } = useDataChanges();

  useEffect(() => {
    if (id) {
      setLoading(true);
      const url = `api/subcourse/${id}/getallsubcourse`;
      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, trigger]);

  useEffect(() => {
    if (dataChanges) {
      const firstSilabus = document.getElementById(`video#${dataChanges}`);
      console.log(firstSilabus);
      firstSilabus?.click();
    }
  }, [data, dataChanges]);

  return (
    <TableContainer>
      {!loading && data && data.length > 0 ? (
        <Table>
          <Thead>
            <Tr>
              <Th pl={5}>#</Th>
              <Th>Video</Th>
              <Th>ID</Th>
              <Th>Judul</Th>
              <Th>Deskripsi</Th>
              <Th>Durasi</Th>
              <Th>Diperbarui</Th>
              <Th pr={5} textAlign={"center"} w={"100px"}>
                Aksi
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {data.map((sub, i) => {
              const searchTerm = search.toLowerCase();
              const ok =
                sub.nama_sub_course.toLowerCase().includes(searchTerm) ||
                sub.description.toLowerCase().includes(searchTerm);

              return (
                ok && (
                  <Tr
                    key={i}
                    _hover={{ bg: "var(--divider)" }}
                    transition={"200ms"}
                  >
                    <Td pl={5}>{i + 1}</Td>

                    <Td>
                      <VideoPreviewOnTable data={sub} url={sub.yt_url} />
                    </Td>

                    <Td>{sub.id.toString().padStart(3, "0")}</Td>

                    <Td>
                      <NoOflinesText w={"180px"}>
                        {sub.nama_sub_course}
                      </NoOflinesText>
                    </Td>
                    <Td>
                      <NoOflinesText w={"180px"}>
                        {sub.description}
                      </NoOflinesText>
                    </Td>
                    <Td whiteSpace={"nowrap"}>
                      {formatDuration(sub.duration)}
                    </Td>
                    <Td whiteSpace={"nowrap"}>{formatDate(sub.updated_at)}</Td>
                    <Td pr={5}>
                      <HStack>
                        <DeleteSilabusModal data={sub} />

                        <UpdateSilabusModal data={sub} />

                        <OrderSilabus
                          silabus={data}
                          setSilabus={setData}
                          data={sub}
                          currentIndex={i + 1}
                          orderLoading={orderLoading}
                          setOrderLoading={setOrderLoading}
                        />
                      </HStack>
                    </Td>
                  </Tr>
                )
              );
            })}
          </Tbody>
        </Table>
      ) : !loading && data && data.length === 0 ? (
        <NoData />
      ) : (
        <ComponentSpinner />
      )}
    </TableContainer>
  );
}
